import { getShortcutOnSelectItem } from '@alpod-ai-writer/plate-plugins/shortcuts';
import { withRef } from '@udecode/cn';
import { PlateElement } from '@udecode/plate/react';
import { filterWords } from '@udecode/plate-combobox';
import { useCallback, useState } from 'react';

import { useShortcutList } from '../../hooks/useShortcutList.hook';
import { type FilterFn,InlineCombobox, InlineComboboxContent, InlineComboboxEmpty, InlineComboboxGroup, InlineComboboxInput, InlineComboboxItem } from '../common/inlineComboBox.component';

const onSelectItem = getShortcutOnSelectItem();

const filterFn: FilterFn = ({ value, group, label, keywords = [] }, search) => {
    if (value === '__new__') {
        return true;
    }

    const uniqueTerms = new Set(
        [value, ...keywords, group, label].filter(Boolean)
    );

    return Array.from(uniqueTerms).some((keyword) =>
        filterWords(keyword!, search)
    );
};

export const ShortcutInputElement = withRef<typeof PlateElement>(
    ({ className, ...props }, ref) => {
        const { shortcutList, addShortcut } = useShortcutList();

        const { children, editor, element } = props;
        const [search, setSearch] = useState('');
        
        const handleSelectItem = useCallback((key: string, label: string) => {
            if (key === '' && label != '') {
                const { id: key } = addShortcut(label);
                onSelectItem(editor, { key, text: key }, search);
            } else {
                onSelectItem(editor, { key, text: key }, search);
            }
        }, [ editor, search ]);

        const isReadOnly = editor.api.isReadOnly();

        return (
            <PlateElement
                ref={ref}
                as="span"
                className={className}
                data-slate-value={element.value}
                {...props}
            >
                {!isReadOnly && (
                    <InlineCombobox
                        value={search}
                        element={element}
                        setValue={setSearch}
                        filter={filterFn}
                        showTrigger={false}
                        trigger="@"
                    >
                        <span className="inline-block rounded-md bg-muted px-1.5 py-0.5 align-baseline text-sm ring-ring focus-within:ring-2 min-w-8 bg-gray-200">
                            <InlineComboboxInput />
                        </span>
                        <InlineComboboxContent className="my-1.5">
                            <InlineComboboxEmpty>(nenalezeno)</InlineComboboxEmpty>
                            <InlineComboboxGroup>
                                {shortcutList.map(([ key, item ]) => (
                                    <InlineComboboxItem
                                        key={key}
                                        value={item.shortcut}
                                        onClick={() => handleSelectItem(key, item.shortcut)}
                                    >
                                        {item.shortcut}
                                    </InlineComboboxItem>
                                ))}
                                {search !== '' && (
                                    <InlineComboboxItem
                                        value={'__new__'}
                                        onClick={() => handleSelectItem('', search)}
                                    >
                                Vytvořit: {search}
                                    </InlineComboboxItem>
                                )}
                            </InlineComboboxGroup>
                        </InlineComboboxContent>
                    </InlineCombobox>
                )}
                {children}
            </PlateElement>
        );
    }
);
